import { STATUS } from '~/literals';

import { Topic } from '~/types';

export const description = 'CreateMyInvoice Platform';
export const name = 'CreateMyInvoice';
export const topic: Topic = {
  cached: false,
  data: [],
  message: '',
  status: STATUS.IDLE,
  updatedAt: 0,
};

export const MOBILE_WIDTH = 900;

export const MOBILE_QRY = `@media only screen and (min-width: ${MOBILE_WIDTH}px)`;
